import type { JsonObject } from "../../shared/api/types";

export const defaultProfileConfig: JsonObject = {
  initial_candidates: 6,
  models: { chat_model: "", embedding_model: "" },
  generation: { temperature: 0.2, max_tokens: 3000 },
  search: {
    exact_enabled: true,
    fulltext_enabled: true,
    vector_enabled: true,
    exact_weight: 1,
    fulltext_weight: 1,
    vector_weight: 1,
    rrf_k: 60,
  },
  graph: {
    max_depth: 1,
    max_related_cards: 15,
    include_reverse_edges: false,
    relations: {
      "зависит_от": { enabled: true, max_entities: 5, always_include: true },
      "семейство_изделия": { enabled: true, max_entities: 1, always_include: true },
      "применяется_к": { enabled: true, max_entities: 4, always_include: false },
      "уточняет": { enabled: true, max_entities: 4, always_include: false },
      "источники": { enabled: true, max_entities: 5, always_include: false },
    },
  },
  knowledge_status_weights: { "действует": 1, "черновик": 0.7, "устарела": 0 },
  context: {
    max_cards: 24,
    max_chunks_per_card: 3,
    max_characters: 45000,
    include_properties: true,
    include_sources: true,
  },
  conversation: { recent_messages: 8 },
  answer: { mention_missing_data: true, refuse_on_missing_data: false },
};
